import React from 'react'

import { Tag } from 'antd'
import { configureField } from '../../../../core/utils/list'

import Moment from 'moment'
import { DATETIME_FORMAT } from '../../../../core/utils/i18n-js'

const stateToColor = (st) => {
  if (st === 'PROCESSED') {
    return 'green'
  }
  if (st === 'PENDING') {
    return 'blue'
  }

  return 'volcano'
}

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden } = props

  if (loading) return []

  return [
    {
      title: 'ID #',
      dataIndex: 'id',
      width: 70,
      ...configureField('mq.id', filters, resize, hidden, true, false, false, 200),
      render: (id) => `N-${id}`
    },
    {
      title: 'Date',
      dataIndex: 'created_date',
      ...configureField('mq.createdDate', filters, resize, hidden, false, true, true, 200),
      render: (date) => {
        return Moment(date).format(DATETIME_FORMAT)
      }
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      ...configureField('mq.subject', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'To',
      dataIndex: 'mail_to',
      ...configureField('mq.mailTo', filters, resize, hidden, true, false, false, 200)
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 100,
      ...configureField('mq.status', filters, resize, hidden, true, false, false, 200),
      render: (st) => <Tag color={stateToColor(st)}> {st} </Tag>
    }
  ]
}
